import { Component, OnInit } from '@angular/core';
import { ComponentBase } from 'src/app/main/dynamic/component-base';

import * as jQuery from 'jquery';
import { AttributeModel } from 'src/app/main/dynamic/model/attribute.model';


@Component({
  selector: 'app-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss']
})
export class InputComponent extends ComponentBase implements OnInit {

  constructor() {
    super()
  }

  ngOnInit() {
  }

  ngBlurInput(e, attribute: any) {
  }

  ngChangeInput(e, options: any) {
    let hide = options.find(option => option.key == 'hideElement');
    let disabled = options.find(option => option.key == 'disabledElement');

    if (hide.value == 'false' && disabled.value == 'true') {
      if (e.target.type == 'checkbox' && !e.target.checked) {
        let checkbox: string = e.target.id;
        let textbox: string = checkbox.replace('ddl', 'txt');
        $('#' + textbox).attr('disabled', 'disabled');
        $('#' + textbox).val('');
      }
      else if (e.target.type == 'checkbox') {
        let checkbox: string = e.target.id;
        let textbox: string = checkbox.replace('ddl', 'txt');
        $('#' + textbox).removeAttr('disabled');
      }
    }
    else if (hide.value == 'true' && disabled.value == 'false') {
      if (e.target.type == 'checkbox' && !e.target.checked) {
        let checkbox: string = e.target.id;
        let textbox: string = checkbox.replace('ddl', 'txt');
        $('.' + textbox).fadeIn();
      }
      else if (e.target.type == 'checkbox') {
        let checkbox: string = e.target.id;
        let textbox: string = checkbox.replace('ddl', 'txt');
        $('.' + textbox).fadeOut();
      }
    }
  }

  ngGetComponentType(attribute: AttributeModel): string {

    if (attribute.type.toUpperCase() == "Boolean".toUpperCase())
      return "checkbox";
    else if (attribute.type == "BooleanoExclusivo")
      return "radio";
    else
      return "text";
  }

  ngGetBooleanComponent(attribute: AttributeModel): boolean {
    if (attribute.type.toUpperCase() == "Boolean".toUpperCase())
      return true;
    else
      return false;
  }

  ngGetBooleanoExclusivoComponent(attribute: AttributeModel): boolean {
    if (attribute.type.toUpperCase() == "BooleanoExclusivo".toUpperCase())
      return true;
    else
      return false;
  }

  ngGetTextComponent(attribute: AttributeModel): boolean {
    if (attribute.type.toUpperCase() == "Text".toUpperCase())
      return true;
    else
      return false;
  }
}
